import { render } from "./EditMeetingPoints.vue?vue&type=template&id=305a2088&scoped=true"
import script from "./EditMeetingPoints.vue?vue&type=script&lang=js"
export * from "./EditMeetingPoints.vue?vue&type=script&lang=js"

import "./EditMeetingPoints.vue?vue&type=style&index=0&id=305a2088&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305a2088"]])

export default __exports__